"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAvatarMultiple = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var sizingProps = {
    small: {
        selectSize: "middle",
        avatarGroupSize: "small",
    },
    default: {
        selectSize: "large",
        avatarGroupSize: "default",
    },
};
var StyledSelect = styled_components_1.default(antd_1.Select)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    .ant-select-selection-overflow-item-rest {\n      display: none;\n    }\n    .ant-avatar-group {\n      display: block;\n    }\n  }\n"], ["\n  &&& {\n    .ant-select-selection-overflow-item-rest {\n      display: none;\n    }\n    .ant-avatar-group {\n      display: block;\n    }\n  }\n"])));
/**
 * SelectAvatarMultiple
 * - Ant-design select with only multiple mode support for multiple avatar selection.
 */
var SelectAvatarMultiple = function (_a) {
    var value = _a.value, _b = _a.maxAvatarCount, maxAvatarCount = _b === void 0 ? 3 : _b, renderTitle = _a.renderTitle, getAvatarProps = _a.getAvatarProps, avatarProps = _a.avatarProps, avatarGroupProps = _a.avatarGroupProps, _c = _a.size, size = _c === void 0 ? "default" : _c, rest = __rest(_a, ["value", "maxAvatarCount", "renderTitle", "getAvatarProps", "avatarProps", "avatarGroupProps", "size"]);
    return (react_1.default.createElement(StyledSelect, __assign({}, rest, { value: value, mode: "multiple", maxTagCount: 1, size: sizingProps[size].selectSize, tagRender: function () { return (react_1.default.createElement(antd_1.Space, { align: "center" },
            react_1.default.createElement(antd_1.Avatar.Group, __assign({}, avatarGroupProps, { maxCount: maxAvatarCount, size: sizingProps[size].avatarGroupSize }), react_1.default.Children.toArray(value === null || value === void 0 ? void 0 : value.map(function (v) { return (react_1.default.createElement(antd_1.Avatar, __assign({}, avatarProps, getAvatarProps === null || getAvatarProps === void 0 ? void 0 : getAvatarProps(v)))); }))),
            renderTitle(value))); } })));
};
exports.SelectAvatarMultiple = SelectAvatarMultiple;
var templateObject_1;
